import React from 'react';

class PasswordInstructions extends React.Component {
    render() {
        return (
            <div className="login-box-password-notation">
                <p>Your new password must adhere to the following:</p>
                <ul>
                    <li>Contain between 8 and 256 characters</li>
                    <li>Contain at least one alphabetic character</li>
                    <li>At least one of the alphabetic characters must be capitalized</li>
                    <li>Contain at least one numeric value</li>
                    <li>Contain one special character.  The allowable special characters include: !@#$%&*()_-+=</li>                               
                </ul>
            </div>
        )
    }
}

export default PasswordInstructions;



// WEBPACK FOOTER //
// ./src/areas/shared/components/passwordInstructions/PasswordInstructions.js